<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-desktop page-icon"></i>
			</div>

			<div>
				<div class="text-center">LISTA</div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2 disabled"><i class="fa fa-lg mb-2 fa-search"></i><br />Szűrő</button><br />
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
			</div>
		</div>

		<div class="col-3 list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<div class="float-end pt-4" style="width:150px;">
							<div class="input-group">
								<input type="text" class="form-control" id="status-search" placeholder="Keresés..." oninput="Anvil.page.quickSearch($(this).val())" />
								<span class="input-group-text"><i class="fa fa-search"></i></span>
							</div>
						</div>

						<h2>Cégek</h2>
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item">Termék menedzsment</li>
							<li class="breadcrumb-item">c-Order</li>
							<li class="breadcrumb-item active">Terminálok</li>
						</ol>
					</div>

					<%- include('/ui/grid', {
						name: 'company',
						params: {
							row_height: 68,
							onselect (rows) {
								if (rows.length == 0) return
								Anvil.page.select(rows[0])
							},
							render_footer (list) {
								let total = 0
								for (let company of list.data) {
									total += company.licence_fee
								}
								return `Összes havidíj: <strong class="m-0 p-0" style="color:goldenrod;">${Anvil.numeral(total).format('0,0')} Ft</strong>`
							},
							columns: [
								{
									title: 'Cég',
									field: 'name',
									type: {
										render: (value, row, options) => `
											<strong>${row.name}</strong><br />
											<small>
												${row.tax_number}<br />
												${row.invoice_area_code} ${row.invoice_city}, ${row.invoice_address}
											</small>
										`
									},
									width: 320,
								},
								{
									title: 'Terminálok',
									field: 'terminal_count',
									type: {
										render: (value, row, options) => `
											<br />
											<small>
												${row.terminal_count} terminál<br />
												<strong style="color:goldenrod;">${Anvil.numeral(row.licence_fee).format('0,0')} Ft/hó</strong>
											</small>
										`
									},
									options: {
										class: 'text-end'
									},
									width: 110
								}
							]
						},
						list
					}) %>

				</div>
			</div>

			<div class="py-3">
				<button onclick="history.back()" class="btn btn-dark"><i class="fa fa-angle-left me-2"></i>Vissza</button>
				<div class="float-end">
				</div>
			</div>

		</div>

		<div class="col ps-0 list-panel" id="panel_terminal_browser">
			<%- include('panel_terminal_browser', { company: null }) %>
		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	async quickSearch (expression) {
		Anvil.models.components.Grid.find('#company_grid').filter(expression)
	},

	async quickSearchTerminal (expression) {
		//Anvil.models.components.Grid.find('#terminal_grid').filter(expression)
	},

	async select (company) {
		Anvil.page.company = company
		Anvil.render('c_order/terminal/panel_terminal_browser', { company }, '#panel_terminal_browser')

		// Init tooltips
		var tooltip_els = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
		var tooltip_list = tooltip_els.map((el) => new bootstrap.Tooltip(el))
	},

	async connect_with_anydesk (machine_id) {

		// Find terminal
		var terminal = undefined
		for (const site of Anvil.page.company.sites) {
			terminal = site.terminals.find(t => t.machine_id == machine_id)
			if (terminal !== undefined) break
		}

		if (terminal !== undefined) {
			// Request confirmation
			Anvil.confirm({
				title: 'Anydesk kapcsolat',
				message: `
					<p>Biztosan szeretnél csatlakozni a kiválasztott terminálhoz?</p>
					<table style="font-size:0.9em;">
						<tr>
							<td class="pe-3">Cég</td>
							<td><strong>${terminal.company_name}</strong></td>
						</tr>
						<tr>
							<td class="pe-3">Telephely</td>
							<td><strong>${terminal.site_name}</strong></td>
						</tr>
						<tr>
							<td class="pe-3" valign="top">Terminál</td>
							<td><strong>${terminal.device_info.hostname || terminal.name}</strong><br /><br /></td>
						</tr>
						<tr>
							<td class="pe-3">Anydesk ID</td>
							<td><strong>${terminal.anydesk_id}</strong></td>
						</tr>
					</table>
				`,
				btn_ok: `<i class="fa fa-headset me-2"></i>Csatlakozás`,
				btn_cancel: `<i class="fa fa-running me-2"></i>Mégse`,
				btn_ok_class: 'warning',
				onclose: (confirmed) => {
					if (confirmed) {
						window.open(`anydesk:${terminal.anydesk_id}`, '_self')
					}
				}
			})
		}
	},

	async open (machine_id) {

		// Find terminal
		var terminal = undefined
		for (const site of Anvil.page.company.sites) {
			terminal = site.terminals.find(t => t.machine_id == machine_id)
			if (terminal !== undefined) break
		}

		if (terminal !== undefined) {
			// Open edit modal
			Anvil.exec('c_order/terminal/modal_edit', terminal)
		}
	}

})
</script>
